import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/donate/tinkoff.svg'
import _imports_1 from '@/assets/donate/alena_samarina_animoji.png'
import _imports_2 from '@/assets/donate/vk.svg'
import _imports_3 from '@/assets/vk.png'
import _imports_4 from '@/assets/tg.png'


const _withScopeId = n => (_pushScopeId("data-v-32cb4632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "donate" }
const _hoisted_2 = { class: "donate__contents" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "donate__heading" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"donate__heading-donators\" data-v-32cb4632><svg width=\"26\" height=\"29\" viewBox=\"0 0 26 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32cb4632><rect width=\"26\" height=\"29\" rx=\"13\" fill=\"#FFFF00\" data-v-32cb4632></rect><path d=\"M10.6807 15.9941H12.082V16.5547C12.082 17.735 11.8132 18.6283 11.2754 19.2344C10.7376 19.8359 9.97656 20.1367 8.99219 20.1367C8.00781 20.1367 7.24447 19.8337 6.70215 19.2275C6.16439 18.6214 5.89551 17.7305 5.89551 16.5547V12.9453C5.89551 11.7695 6.16439 10.8786 6.70215 10.2725C7.24447 9.66634 8.00781 9.36328 8.99219 9.36328C9.97656 9.36328 10.7376 9.66634 11.2754 10.2725C11.8132 10.874 12.082 11.765 12.082 12.9453V13.3623H10.6807V12.9453C10.6807 12.1341 10.5371 11.5485 10.25 11.1885C9.96745 10.8285 9.54818 10.6484 8.99219 10.6484C8.44076 10.6484 8.01921 10.8285 7.72754 11.1885C7.44043 11.5485 7.29688 12.1341 7.29688 12.9453V16.5547C7.29688 17.3659 7.44043 17.9515 7.72754 18.3115C8.01465 18.6715 8.4362 18.8516 8.99219 18.8516C9.54362 18.8516 9.96289 18.6715 10.25 18.3115C10.5371 17.9515 10.6807 17.3659 10.6807 16.5547V15.9941ZM18.3046 20L15.208 14.832V20H13.8134V9.5H15.208V14.6133L18.2773 9.5H19.8154L16.664 14.5244L19.9863 20H18.3046Z\" fill=\"black\" data-v-32cb4632></path></svg><svg width=\"26\" height=\"29\" viewBox=\"0 0 26 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32cb4632><rect width=\"26\" height=\"29\" rx=\"13\" fill=\"black\" data-v-32cb4632></rect><path d=\"M12.2578 20V10.5527L10.1318 20H8.43652L6.32422 10.5049V20H5.03906V9.5H7.43164L9.3457 18.1543L11.2256 9.5H13.6592V20H12.2578ZM20.0117 20L16.915 14.832V20H15.5205V9.5H16.915V14.6133L19.9843 9.5H21.5224L18.3711 14.5244L21.6933 20H20.0117Z\" fill=\"white\" data-v-32cb4632></path></svg><svg width=\"26\" height=\"29\" viewBox=\"0 0 26 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-32cb4632><rect width=\"26\" height=\"29\" rx=\"13\" fill=\"#F6526B\" data-v-32cb4632></rect><path d=\"M7.1709 20L9.52246 9.5H11.6211L13.9727 20H12.5576L12.0107 17.4229H9.12598L8.5791 20H7.1709ZM9.40625 16.1377H11.7305L10.5684 10.6211L9.40625 16.1377ZM14.9658 20V9.5H19.6074V10.7852H16.3603V20H14.9658Z\" fill=\"white\" data-v-32cb4632></path></svg><span data-v-32cb4632>12+</span></div>", 1)
const _hoisted_7 = { class: "donate__links" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "tinkoff"
}, null, -1))
const _hoisted_9 = { class: "donate__links-item__contents" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "alena_samarina_animoji"
}, null, -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "vkdonat"
}, null, -1))
const _hoisted_14 = { class: "donate__links-item__contents" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "donate__footer" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"donate__footer-social\" data-v-32cb4632><a href=\"https://vk.com/inkast_me\" target=\"_blank\" data-v-32cb4632><img src=\"" + _imports_3 + "\" alt=\"\" data-v-32cb4632></a><a href=\"https://t.me/inkast_me\" target=\"_blank\" data-v-32cb4632><img src=\"" + _imports_4 + "\" alt=\"\" data-v-32cb4632></a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", {
              innerHTML: _ctx.t('Donate.title')
            }, null, 8, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.event('Clicked Tinkoff')), ["stop"])),
              href: "https://www.tinkoff.ru/rm/samarina.alena19/LoAhG2156/",
              class: "donate__links-item",
              target: "_blank"
            }, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", {
                  innerHTML: _ctx.t('Donate.variants.viaInternet.title')
                }, null, 8, _hoisted_10),
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("p", {
                    innerHTML: _ctx.t('Donate.variants.viaInternet.description')
                  }, null, 8, _hoisted_12)
                ])
              ])
            ]),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.event('Clicked VK')), ["stop"])),
              href: "https://vk.com/inkast_me?source=description&w=donut_payment-212269763",
              class: "donate__links-item",
              target: "_blank"
            }, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h3", {
                  innerHTML: _ctx.t('Donate.variants.vk.title')
                }, null, 8, _hoisted_15),
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    class: "donate__links-item__contents-custom",
                    innerHTML: _ctx.t('Donate.variants.vk.description')
                  }, null, 8, _hoisted_16)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.event('Clicked Problems')), ["stop"])),
            href: "mailto:donation@inkast.me?subject=Проблемы с донатом",
            target: "_blank",
            innerHTML: _ctx.t('Donate.problems')
          }, null, 8, _hoisted_18),
          _hoisted_19
        ])
      ])
    ])
  ], 64))
}